import { useCallback } from 'react'
import PersonalImportEditor, { ImportExecuteResult } from './PersonalImportEditor'

export type { ImportExecuteResult }

interface BulkImportTabProps {
  onImportComplete?: (result: ImportExecuteResult) => void
}

export function BulkImportTab({ onImportComplete }: BulkImportTabProps) {
  const handleImportComplete = useCallback((result: ImportExecuteResult) => {
    onImportComplete?.(result)
  }, [onImportComplete])

  return (
    <div className="p-6 max-w-6xl">
      <PersonalImportEditor
        onImportComplete={handleImportComplete}
      />
    </div>
  )
}
